import { Component, Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { ScopeVersion } from '@app/core/model/scope-version'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { ChangeRequestSelectors } from '../../store/selectors/change-request.selectors'
@Component({
  selector: 'change-request-list',
  templateUrl: './change-request-list.component.html',
  styleUrls: ['./change-request-list.component.scss'],
})
export class ChangeRequestListComponent {
  @Input() currentScope: ScopeVersion
  @Input() currentChangeRequest: ChangeRequest
  @Input() cdnConfig: CdnConfig
  @Input() sections: ScopeSection[]

  @Input() mainColumnClass: string
  @Input() componentMainColumnClass: string
  @Input() roleMainColumnClass: string

  deliverables$ = this.store$.select(ChangeRequestSelectors.selectNetChangesUnsectionedDeliverables)
  sections$ = this.store$.select(ChangeRequestSelectors.selectNetChangesSections)

  constructor(private store$: Store) {}
}
